// extracted by mini-css-extract-plugin
export var content = "_qw-1";
export var divider = "_qw-0";